// API configuration for the customer app.
//
// Both origins come from the build environment (see HOSTING.md), never from code:
//   VITE_API_URL  backend origin, e.g. https://api.example.com (no trailing slash, no /api)
//   VITE_WS_URL   Socket.IO origin; defaults to VITE_API_URL
// In development (`npm run dev`) they can stay unset: requests then go to the Vite dev server, which proxies
// /api and /socket.io to the local backend (vite.config.js). A production build stops without VITE_API_URL
// (vite.config.js), so a hosted app never calls its own origin by mistake.

const trim = v => (v || '').trim().replace(/\/+$/, '')

export const API_BASE_URL = trim(import.meta.env.VITE_API_URL)
export const WS_BASE_URL = trim(import.meta.env.VITE_WS_URL) || API_BASE_URL

// Socket.IO namespaces (backend realtime/index.js; /realtime requires a customer token)
export const SOCKET_URLS = {
  REALTIME: `${WS_BASE_URL}/realtime`,
}
